// GSAP version of ExplainerScene's CSS beats. Gets gsap and the <svg>, returns the timeline.
export default function timeline(gsap, root) {
  const q = (n) => root.querySelector(`[data-anim="${n}"]`);
  const bump = { y: -4, scale: 1.08, transformOrigin: '50% 100%', duration: 0.2, yoyo: true, repeat: 1 };
  return gsap.timeline({ defaults: { ease: 'power2.out' } })
    .from(root.querySelectorAll('.trail'), { strokeDashoffset: 20, duration: 1.6, ease: 'none' }, 0)
    .to(q('phone'), bump, 0.1)
    .fromTo(q('dot-in'), { opacity: 1, x: 0 }, { x: 32, duration: 0.6, ease: 'power1.in' }, 0.35)
    .to(q('dot-in'), { opacity: 0, duration: 0.1 }, 0.9)
    .to(q('hub'), { scale: 1.08, svgOrigin: '306 54', duration: 0.2, yoyo: true, repeat: 1 }, 0.9)
    .from([0, 1, 2].map((i) => q(`chip-${i}`)), { opacity: 0, x: -10, scale: 0.6, transformOrigin: '0% 50%', stagger: 0.1, duration: 0.4, ease: 'back.out(3)' }, 1)
    .fromTo(q('dot-out'), { opacity: 1, x: 0 }, { x: -44, duration: 0.7 }, 1.45)
    .to(q('dot-out'), { opacity: 0, duration: 0.1 }, 2.1)
    .to(q('city'), bump, 1.75)
    .fromTo(root.querySelector('.glow'), { opacity: 0, scale: 0.4 }, { opacity: 0.28, scale: 1, transformOrigin: '50% 50%', duration: 0.9, ease: 'elastic.out(1, 0.5)' }, 2.15);
}
